import React from 'react';
import choice1 from '@/js/images/server_down-1.svg';
import choice2 from '@/js/images/server_down-2.svg';
import choice3 from '@/js/images/server-down-3.svg';
import choice4 from '@/js/images/server_down-4.svg';

const Error404 = () => {
  // Generate a random number between 1-4 and select what svg to load based on that number
  const randomChoice = Math.floor(Math.random() * 4) + 1;
  let choice = choice1;

  switch (randomChoice) {
    case 1:
      choice = choice1;
      break;
    case 2:
      choice = choice2;
      break;
    case 3:
      choice = choice3;
      break;
    case 4:
      choice = choice4;
      break;
    default:
      choice = choice1;
      break;
  }

  return (
    <div className=" flex items-center justify-center px-4 h-[calc(100vh-70px)]">
      <div className="max-w-lg w-full text-center">
        <h1 className="text-6xl font-bold text-lightPurple mb-8">4 Oh! 4</h1>
        <div className="mb-8">
          <img src={choice} alt="404" />
          {/* <svg
            className="mx-auto"
            width="200"
            height="200"
            viewBox="0 0 200 200"
          >
            <circle
              cx="100"
              cy="100"
              r="90"
              fill="none"
              stroke="#8B5CF6"
              strokeWidth="10"
              strokeDasharray="565.48"
              strokeDashoffset="565.48"
            >
              <animate
                attributeName="stroke-dashoffset"
                from="565.48"
                to="0"
                dur="0.8s"
                fill="freeze"
              />
            </circle>
            <circle cx="70" cy="80" r="10" fill="#8B5CF6" opacity="0">
              <animate
                attributeName="opacity"
                values="0;1"
                dur="0.3s"
                fill="freeze"
                begin="0.8s"
              />
            </circle>
            <circle cx="130" cy="80" r="10" fill="#8B5CF6" opacity="0">
              <animate
                attributeName="opacity"
                values="0;1"
                dur="0.3s"
                fill="freeze"
                begin="0.8s"
              />
            </circle>
            <path
              d="M60,140 Q100,110 140,140"
              fill="none"
              stroke="#8B5CF6"
              strokeWidth="10"
              strokeLinecap="round"
              strokeDasharray="150"
              strokeDashoffset="150"
            >
              <animate
                attributeName="stroke-dashoffset"
                from="150"
                to="0"
                dur="0.4s"
                fill="freeze"
                begin="1.1s"
              />
            </path>
          </svg> */}
        </div>
        <h2 className="text-3xl font-semibold text-gray-800 mb-4">
          We lost this page
        </h2>
        <p className="text-gray-800 mb-8">
          We searched high and low but couldn't find what you're looking for.
          Let's find a better place for you to go.
        </p>
        <a
          href="/"
          className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-lightPurple hover:bg-darkerPurple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition"
        >
          Go to Homepage
        </a>
      </div>
    </div>
  );
};
export default Error404;
